import {
  mdiDotsSquare,
  mdiViewDashboardOutline,
  mdiAccountClockOutline,
  mdiScriptTextOutline,
  mdiDatabaseOutline,
  mdiCogs,
  mdiFileChartOutline,
  mdiViewList,
  mdiChartBoxOutline,
  mdiChartBar,
  mdiFileChartPlusOutline,
  mdiCalendarClock,
  mdiQrcode,
} from '@mdi/js'
import { format } from 'date-fns'
import useCurrentData from '@/views/composable/useCurrentData'

const buildRoute = (name, clubSlug) => ({
  name,
  params: {
    club_slug: clubSlug,
  },
})

export default function sidebarContent() {
  // リアクティブな singleton から読むことで、setCurrentClub 経由の更新が
  // 呼び出し側 (Layout の computed) で検知されリロード不要になる
  const { currentClub: currentClubRef, userAbilities: userAbilitiesRef } = useCurrentData()
  const currentClub = currentClubRef.value || {}
  const userAbilities = userAbilitiesRef.value || []
  const clubSlug = currentClub?.slug

  return [
    {
      title: 'ホール',
      icon: mdiDotsSquare,
      to: buildRoute('waiter-halls', clubSlug),
      resource: 'Waiter',
    },
    {
      title: 'フロアマップ',
      icon: mdiViewDashboardOutline,
      to: buildRoute('waiter-floor', clubSlug),
      resource: 'Waiter',
    },
    {
      title: 'オーダー',
      icon: mdiScriptTextOutline,
      to: buildRoute('waiter-orders', clubSlug),
      resource: 'Waiter',
    },
    {
      title: '勤怠/待機',
      icon: mdiAccountClockOutline,
      to: buildRoute('waiter-timecards', clubSlug),
      resource: 'Waiter',
    },
    {
      title: '営業予定',
      icon: mdiCalendarClock,
      to: buildRoute('waiter-business-schedule', clubSlug),
      resource: 'Waiter',
    },
    {
      title: '打刻QRコード',
      icon: mdiQrcode,
      to: buildRoute('admin-cast-app-punch-qr', clubSlug),
      resource: 'Waiter',
      action: 'read',
    },
    // 「日報」は1項目で、保有権限に応じて遷移先を3分岐する（道C: 日報βへ集約）。
    // 優先順: eod_report（manage）（日報β統合版） > eod_closing（新版） > なし（旧版）
    (() => {
      if (userAbilities?.findIndex(a => a.subject === 'eod_report') >= 0) {
        return {
          title: '日報',
          icon: mdiFileChartOutline,
          to: buildRoute('daily-report-summary', clubSlug),
          resource: 'eod_report',
          action: 'manage',
          // 日報β統合版（daily-report-summary）へ遷移するため、データ整合性診断で
          // 未保存があれば赤ドットバッジを点灯させる。点灯判定は VerticalNavMenuLink.vue 側。
          diagnosticsBadge: true,
        }
      }

      if (userAbilities?.findIndex(a => a.subject === 'eod_closing') >= 0) {
        return {
          title: '日報',
          icon: mdiFileChartOutline,
          to: buildRoute('eod-report', clubSlug),
          resource: 'eod_closing',
          action: 'manage',
          // NOTE: 一旦、日報の未集計（赤ドット）バッジは非表示にする。日報β側のみ点灯。
          diagnosticsBadge: false,
        }
      }

      return {
        title: '日報',
        icon: mdiFileChartOutline,
        to: buildRoute('waiter-daily-reports', clubSlug),
        resource: 'Admin',
        // NOTE: 一旦、旧版日報の未集計（赤ドット）バッジは非表示にする。日報β統合版側のみ点灯。
        diagnosticsBadge: false,
      }
    })(),
    {
      title: 'データ',
      icon: mdiDatabaseOutline,
      to: buildRoute('waiter-data', clubSlug),
      resource: 'Waiter',
    },
    {
      title: '設定',
      icon: mdiCogs,
      children: [
        {
          title: 'フロアレイアウト',
          to: buildRoute('waiter-settings-floor', clubSlug),
          resource: 'Waiter',
        },
        {
          title: 'ホール',
          to: buildRoute('waiter-settings-halls', clubSlug),
          resource: 'Waiter',
        },
        {
          title: 'プリンタ設定',
          to: buildRoute('waiter-settings-printers', clubSlug),
          resource: 'Waiter',
        },
        {
          title: 'メニュー',
          to: buildRoute('waiter-settings-vendibles', clubSlug),
          resource: 'Waiter',
        },
        {
          title: '商品タグ',
          to: buildRoute('waiter-settings-vendible-tags', clubSlug),
          resource: 'Waiter',
        },
        {
          title: '在庫管理',
          to: buildRoute('admin-inventory', clubSlug),
          resource: 'inventory',
          action: 'manage',
        },
        {
          title: `${currentClub?.referralAlias || 'リファラル'}`,
          to: buildRoute('waiter-settings-referrals', clubSlug),
          resource: 'Waiter',
        },
        {
          title: '顧客タグ',
          to: buildRoute('waiter-settings-customer-tags', clubSlug),
          resource: 'Waiter',
        },
        {
          title: '顧客管理',
          to: buildRoute('waiter-settings-customer-management', clubSlug),
          resource: 'Waiter',
        },
        {
          title: '売上計上トリガー',
          to: buildRoute('waiter-settings-vending-contribution-triggers', clubSlug),
          resource: 'Waiter',
        },
        {
          title: 'ユーザー',
          to: buildRoute('waiter-settings-users', clubSlug),
          resource: 'Waiter',
        },
        {
          title: '諸入費ラベル',
          to: buildRoute('waiter-settings-book-tags', clubSlug),
          resource: 'Admin',
        },
        {
          title: '日報β設定',
          icon: mdiFileChartPlusOutline,
          resource: 'Admin',
          to: buildRoute('admin-report-settings', clubSlug),
        },
        {
          title: `${currentClub?.name || '店舗'}`,
          to: buildRoute('waiter-settings-club', clubSlug),
          resource: 'Waiter',
        },
      ],
    },
  ]
}
